import { render, staticRenderFns } from "./BugReport.vue?vue&type=template&id=4c27b914&scoped=true&"
import script from "./BugReport.vue?vue&type=script&lang=js&"
export * from "./BugReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c27b914",
  null
  
)

export default component.exports